import React from 'react';
import { Text, StyleSheet, TouchableOpacity, Alert, View } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { useTranslation } from 'react-i18next';
import { Paprika, PaprikaSpacing, PaprikaTypography } from '../../styles/theme';

interface DeleteRecipeButtonProps {
  recipeTitle: string;
  onDelete: () => void;
  align?: 'center' | 'left';
}

/**
 * Destructive delete affordance. Never deletes directly — always opens a
 * confirmation Alert first.
 */
export const DeleteRecipeButton: React.FC<DeleteRecipeButtonProps> = ({
  recipeTitle,
  onDelete,
  align = 'center',
}) => {
  const { t } = useTranslation();

  const confirm = () => {
    Alert.alert(
      t('recipeDetail.deleteTitle', 'Supprimer la recette'),
      t(
        'recipeDetail.deleteConfirm',
        `Voulez-vous vraiment supprimer « ${recipeTitle} » ? Cette action est irréversible.`
      ),
      [
        { text: t('common.cancel', 'Annuler'), style: 'cancel' },
        {
          text: t('common.delete', 'Supprimer'),
          style: 'destructive',
          onPress: onDelete,
        },
      ]
    );
  };

  return (
    <View style={[styles.wrapper, align === 'left' && styles.wrapperLeft]}>
      <TouchableOpacity style={styles.button} onPress={confirm} activeOpacity={0.7}>
        <Feather name="trash-2" size={16} color={Paprika.destructive} />
        <Text style={styles.text}>{t('recipeDetail.deleteRecipe', 'Supprimer la recette')}</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    marginTop: PaprikaSpacing.xl,
    marginHorizontal: PaprikaSpacing.lg,
  },
  wrapperLeft: {
    alignItems: 'flex-start',
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: PaprikaSpacing.xs,
    paddingVertical: PaprikaSpacing.md,
  },
  text: {
    ...PaprikaTypography.bodySmall,
    color: Paprika.destructive,
  },
});

export default DeleteRecipeButton;
